import { atom } from 'jotai';
import { Project_Base } from '~/common/typescript/models/Project';
import {
  AC_Project,
  AC_Project_Permission,
  AC_Project_Role,
} from '~/common/typescript/services/access_control/AC_Project';
import { AC_TLGeo_Role } from '~/common/typescript/services/access_control/AC_Tlgeo';
import { userACRoles } from '~/stores/UserStore';

const ProjectStore = atom<Project_Base | null>(null);

export const currentProjectAtom = atom<Project_Base | undefined>(undefined);

export const projectRolesAtom = atom<AC_Project_Role[]>([]);

export const projectPermissionsAtom = atom<AC_Project_Permission[]>((get) => {
  const roles = get(projectRolesAtom);
  return AC_Project.getPermissions(roles);
});

export const canManageProjectUserAtom = atom<boolean>((get) => {
  const tlgeoRoles = get(userACRoles);
  if (tlgeoRoles.includes(AC_TLGeo_Role.TLGEO_ADMIN)) {
    return true;
  }
  const roles = get(projectRolesAtom);
  if (roles.includes(AC_Project_Role.PROJECT_ADMIN)) {
    return true;
  }
  const permissions = get(projectPermissionsAtom);
  return permissions.includes(AC_Project_Permission.MANAGE_USER);
});

export default ProjectStore;

